export default __webpack_public_path__ + "static/Success-8b2d37795c6d4a368734f8c69b6906c8.png";